import gql from 'graphql-tag';

export const QUERY_LANDLORD_ORDERS = gql`
  query queryLandlordOrders(
    $pageNumber: PositiveInteger = 1
    $pageSize: PositiveInteger = 10
    $stages: [OrderStage]
    $referenceId: String
    $passportFullName: NonEmptyString
    $sortBy: OrderSortBy = UPDATED_AT
    $sortDirection: SortDirection = DESCENDING
    $propertyIds: [ID]
    $createdAfter: VerifyDate
  ) {
    viewer {
      ... on LandlordContact {
        company {
          pendingConfirmationOrderCount: orders(
            stages: [WAITING_FOR_CONFIRMATION]
            createdAfter: $createdAfter
            bookingJourneys: [SEMI_AUTOMATIC]
          ) {
            totalCount
          }
          pendingRefundOrderCount: orders(
            stages: [REFUNDING]
            bookingJourneys: [SEMI_AUTOMATIC]
            createdAfter: $createdAfter
          ) {
            totalCount
          }
          orders(
            pageNumber: $pageNumber
            pageSize: $pageSize
            stages: $stages
            referenceId: $referenceId
            passportFullName: $passportFullName
            sortBy: $sortBy
            sortDirection: $sortDirection
            propertyIds: $propertyIds
            bookingJourneys: [SEMI_AUTOMATIC]
          ) {
            totalCount
            edges {
              node {
                billingCycle
                currency
                passportFullName
                orderNotes {
                  createdAt
                  createdBy
                  createdByName
                  id
                  note
                  orderId
                  updatedAt
                  updatedBy
                  updatedByName
                }
                id
                moveInDate
                moveOutDate
                propertyId
                propertyName
                referenceId
                stage
                student {
                  firstName
                  id
                  lastName
                  passportFirstName
                  passportLastName
                  passportMiddleName
                }
                totalPrice
                unitTypeCategory
                unitTypeId
                listingId
                listingSalesPrice
                listingDiscountValue
                unitTypeName
                secondaryStage
                instalmentPlanType
                counterOffers {
                  id
                  moveInDate
                  moveOutDate
                  unitTypeName
                  unitTypeCategory
                  totalPrice
                  currency
                  property {
                    id
                    name
                  }
                }
                property {
                  id
                  name
                  city {
                    slug
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const QUERY_LANDLORD_BOOKINGS = gql`
  query queryLandlordBookings(
    $pageNumber: PositiveInteger = 1
    $pageSize: PositiveInteger = 10
    $referenceId: String
    $passportFullName: NonEmptyString
    $sortBy: BookingSortBy = UPDATED_AT
    $sortDirection: BookingSortDirection = DESCENDING
    $propertyIds: [ID]
    $opportunityStages: [LandlordOpportunityStage!]!
  ) {
    viewer {
      ... on LandlordContact {
        company {
          bookings(
            pageNumber: $pageNumber
            pageSize: $pageSize
            referenceId: $referenceId
            sortBy: $sortBy
            sortDirection: $sortDirection
            propertyIds: $propertyIds
            passportFullName: $passportFullName
            opportunityStages: $opportunityStages
          ) {
            totalCount
            edges {
              node {
                currency
                id
                moveInDate
                moveOutDate
                opportunity {
                  bookingJourney
                  completedXbooking {
                    billingCycle
                    listingMoveIn
                    listingMoveInType
                    listingMoveOut
                    listingMoveOutType
                    propertyName
                    referenceId
                    roomName
                    unitPrice
                    commission {
                      invoiceNumber
                      bonusValue
                      currency
                      totalCommissionValue
                      value
                    }
                  }
                  currency
                  finalMoveInDate
                  finalMoveOutDate
                  finalPrice
                  id
                  stage
                  landlordBookingStatus
                  student {
                    dateOfBirth
                    destinationUniversity
                    emailAddress
                    gender
                    nationality
                    passportFirstName
                    passportLastName
                    passportMiddleName
                    passportNumber
                    phoneNumber
                  }
                }
                price
                propertyName
                referenceId
                student {
                  firstName
                  id
                  lastName
                  passportFirstName
                  passportLastName
                  passportMiddleName
                }
                roomName
                roomType
              }
            }
          }
        }
      }
    }
  }
`;

export const QUERY_INSTANT_ORDERS = gql`
  query queryInstantOrders(
    $pageNumber: PositiveInteger = 1
    $pageSize: PositiveInteger = 10
    $stages: [OrderStage]
    $referenceId: String
    $passportFullName: NonEmptyString
    $sortBy: OrderSortBy = UPDATED_AT
    $sortDirection: SortDirection = DESCENDING
    $propertyIds: [ID]
  ) {
    viewer {
      ... on LandlordContact {
        company {
          orders(
            pageNumber: $pageNumber
            pageSize: $pageSize
            stages: $stages
            referenceId: $referenceId
            passportFullName: $passportFullName
            sortBy: $sortBy
            sortDirection: $sortDirection
            propertyIds: $propertyIds
            bookingJourneys: [INSTANT_BOOK]
          ) {
            totalCount
            edges {
              node {
                currency
                id
                moveInDate
                moveOutDate
                propertyName
                referenceId
                stage
                passportFullName
                student {
                  firstName
                  id
                  lastName
                  passportFirstName
                  passportLastName
                  passportMiddleName
                }
                totalPrice
                unitTypeCategory
                unitTypeId
                unitTypeName
              }
            }
          }
        }
      }
    }
  }
`;

export const EXPORT_LEADGEN_ORDERS = gql`
  query queryLeadGenOrders(
    $pageNumber: PositiveInteger = 1
    $pageSize: PositiveInteger = 10
    $stages: [OrderStage]
    $referenceId: String
    $passportFullName: NonEmptyString
    $sortBy: OrderSortBy = UPDATED_AT
    $sortDirection: SortDirection = DESCENDING
    $propertyIds: [ID]
    $createdAfter: VerifyDate
    $createdBefore: VerifyDate
  ) {
    viewer {
      ... on LandlordContact {
        company {
          orders(
            pageNumber: $pageNumber
            pageSize: $pageSize
            stages: $stages
            referenceId: $referenceId
            passportFullName: $passportFullName
            sortBy: $sortBy
            sortDirection: $sortDirection
            propertyIds: $propertyIds
            createdAfter: $createdAfter
            createdBefore: $createdBefore
            bookingJourneys: [LEAD_GENERATION]
          ) {
            totalCount
            edges {
              node {
                currency
                id
                studentData
                moveInDate
                moveOutDate
                propertyName
                referenceId
                hash
                tenancyLength {
                  days
                  weeks
                }
                createdAt
                stage
                student {
                  dateOfBirth
                  destinationUniversity
                  emailAddress
                  gender
                  passportFirstName
                  passportLastName
                  passportMiddleName
                  passportNumber
                  phoneNumber
                  updatedAt
                }
                orderNotes {
                  note
                }
                property {
                  slug
                  city {
                    slug
                    name
                    country {
                      slug
                      name
                    }
                  }
                }
                totalPrice
                unitTypeCategory
                unitTypeName
              }
            }
          }
        }
      }
    }
  }
`;

export const QUERY_LEADGEN_ORDERS = gql`
  query queryLeadGenOrders(
    $pageNumber: PositiveInteger = 1
    $pageSize: PositiveInteger = 10
    $stages: [OrderStage]
    $referenceId: String
    $passportFullName: NonEmptyString
    $sortBy: OrderSortBy = UPDATED_AT
    $sortDirection: SortDirection = DESCENDING
    $propertyIds: [ID]
    $createdAfter: VerifyDate
    $createdBefore: VerifyDate
    $commissionTriggerPoint: CommissionTriggerPointType
  ) {
    viewer {
      ... on LandlordContact {
        company {
          orders(
            pageNumber: $pageNumber
            pageSize: $pageSize
            stages: $stages
            referenceId: $referenceId
            passportFullName: $passportFullName
            sortBy: $sortBy
            sortDirection: $sortDirection
            propertyIds: $propertyIds
            createdAfter: $createdAfter
            createdBefore: $createdBefore
            bookingJourneys: [LEAD_GENERATION]
            commissionTriggerPoint: $commissionTriggerPoint
          ) {
            totalCount
            edges {
              node {
                id
                moveInDate
                moveOutDate
                propertyName
                referenceId
                passportFullName
                commissionTriggerPoint
                canUpdateListOrderStage
                tenancyLength {
                  days
                  weeks
                }
                createdAt
                student {
                  passportFirstName
                  passportLastName
                  passportMiddleName
                }
                unitTypeCategory
                unitTypeName
              }
            }
          }
        }
      }
    }
  }
`;

export const QUERY_LEAD_ORDER_DETAIL = gql`
  query QUERY_LEAD_ORDER_DETAIL($referenceId: String) {
    viewer {
      ... on LandlordContact {
        company {
          orders(referenceId: $referenceId) {
            edges {
              node {
                landlordConfirmedPayment
                paymentOnline
                externalId
                id
                studentData
                commissionTriggerPoint
                canUpdateListOrderStage
                tenancyLength {
                  days
                  weeks
                }
                orderNotes {
                  createdAt
                  createdBy
                  createdByName
                  id
                  note
                  orderId
                  updatedAt
                  updatedBy
                  updatedByName
                }
                moveInDate
                moveOutDate
                totalPrice
                referenceId
                billingCycle
                bookingJourney
                currency
                cancelledReason
                paidAt
                city {
                  id
                  name
                  country {
                    slug
                  }
                  slug
                }
                passportFirstName
                passportLastName
                paymentDuration
                confirmationDuration
                uploadFiles {
                  name
                  id
                  source
                  type
                }
                landlord {
                  name
                }
                customFieldValues {
                  id
                  value
                  customFieldInternalName
                }
                student {
                  lastName
                  firstName
                  passportFirstName
                  passportLastName
                  passportMiddleName
                  otherPreferences
                  studyMajor
                  dateOfBirth
                  phoneNumber
                  gender
                  customFieldValues
                  emailAddress
                  country
                  state
                  city
                  addressLines
                  postalCode
                  nationality
                  currentUniversity
                  destinationUniversity
                  academicYear
                  userUuid
                }
                guarantor {
                  addressLines
                  city
                  country
                  state
                  dateOfBirth
                  emailAddress
                  firstName
                  lastName
                  phone
                  postalCode
                  gender
                  relationshipWithStudent
                }
                listingId
                instalmentPlanType
                propertyName
                propertyId
                unitTypeId
                unitTypeName
                unitTypeCategory
                listingSalesPrice
                totalPrice
                totalRental
                totalFee
                totalDeposit
                secondaryStage
                counterOffers {
                  discountValue
                  discountType
                  currency
                  listingId
                  stage
                  id
                  moveInDate
                  moveOutDate
                  unitTypeName
                  unitTypeCategory
                  unitTypeName
                  totalPrice
                  currency
                  listingSalesPrice
                  billingCycle
                  totalPrice
                  validPeriodHour
                  createdAt
                  updatedAt
                  rejectReason
                  instalmentPlanType
                  rejectReason
                  stage
                  property {
                    status
                    name
                    address
                    slug
                    bookingJourney
                    city {
                      id
                      name
                      slug
                      country {
                        slug
                      }
                    }
                    paymentPlan {
                      paymentOnline
                    }
                    addressLine2
                    documentations {
                      name
                      check
                      slug
                    }
                  }
                  originOrder {
                    billingCycle
                    currency
                    id
                    property {
                      status
                      name
                      slug
                      bookingJourney
                      city {
                        id
                        name
                        country {
                          slug
                        }
                        slug
                      }
                      address
                      addressLine2
                    }
                    instalmentPlanType
                    listingDiscountType
                    listingDiscountValue
                    listingId
                    listingMaxPrice
                    listingMinPrice
                    listingMoveIn
                    listingMoveInType
                    listingMoveOut
                    listingMoveOutType
                    listingSalesPrice
                    listingTenancyLengthType
                    listingTenancyLengthValue
                    moveInDate
                    moveOutDate
                    totalDeposit
                    totalFee
                    totalRental
                    totalPrice
                    unitTypeCategory
                    unitTypeId
                    unitTypeName
                  }
                }
                stage
                charges {
                  id
                  referenceId
                  chargeAmount
                  chargeCurrency
                  paymentMethod
                  tradeNo
                  stripeChargeId
                }
                payments {
                  amount
                  currency
                  id
                  name
                  paymentCategory
                  updatedAt
                  payThroughStcom
                  price
                  status
                  orderChargeId
                }
                processes {
                  modifierName
                  currentStage
                  updatedAt
                  currentSecondaryStage
                }
                refunds {
                  id
                  referenceId
                  refundType
                  refundMethod
                  status
                  amount
                  currency
                  refundFrom
                  refundTo
                  refundedAt
                  refundMethodDetails
                  transactionNo
                  isTransferred
                  processes {
                    createdAt
                    currentStatus
                  }
                }
                commissions {
                  basePrice
                  bonusCommissionTierType
                  bonusCommissionTierValue
                  bonusPrice
                  commissionTierType
                  commissionTierValue
                  createdAt
                  currency
                  id
                  orderId
                  referenceId
                  status
                  totalPrice
                  updatedAt
                }
                receivables {
                  referenceId
                  receivableType
                  receivableMethod
                  status
                  amount
                  currency
                  invoiceNumber
                  invoicedAt
                  paidAt
                  commission {
                    totalPrice
                    currency
                  }
                }
                transfers {
                  referenceId
                  transferType
                  amount
                  currency
                  status
                  planningTransferDatetime
                  actualTransferDatetime
                  actualTransferDetails
                  actualTransferMethod
                }

                property {
                  status
                  id
                  name
                  slug
                  address
                  bookingJourney
                  addressLine2
                  heroImage {
                    source
                  }
                  city {
                    id
                    name
                    country {
                      slug
                      name
                    }
                    slug
                  }
                  documentations {
                    name
                    check
                    slug
                  }
                  paymentPlan {
                    paymentOnline
                  }
                  commissionTiers {
                    bonus
                    capType
                    capValue
                    category
                    convertedCalculationValue
                    description
                    fullyCalculatable
                    id
                    name
                    percentageForReport
                    retrospectiveCommission
                    status
                    tenancyLengthFrom
                    tenancyLengthTo
                    tenancyUnit
                    type
                    value
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const MUTATION_CONFIRM_ORDER = gql`
  mutation mutationConfirmOrder($input: ConfirmOrderInput) {
    confirmOrder(input: $input) {
      order {
        id
      }
    }
  }
`;
export const CREATE_ORDER_NOTE = gql`
  mutation CreateOrderNote($input: CreateOrderNoteInput!) {
    createOrderNote(input: $input) {
      id
    }
  }
`;

export const UPDATE_ORDER_NOTE = gql`
  mutation UpdateOrderNote($input: UpdateOrderNoteInput!) {
    updateOrderNote(input: $input) {
      id
    }
  }
`;

export const DELETE_ORDER_NOTE = gql`
  mutation DeleteOrderNote($input: DeleteOrderNoteInput!) {
    deleteOrderNote(input: $input) {
      id
    }
  }
`;

export const MUTATION_REJECT_ORDER = gql`
  mutation mutationRejectOrder($input: RejectOrderInput) {
    rejectOrder(input: $input) {
      order {
        id
      }
    }
  }
`;

export const QUERY_PROPERTY_STATISTICS = gql`
  query queryPropertyStatistics {
    viewer {
      ... on LandlordContact {
        instantProperty: properties(bookingJourneys: [INSTANT_BOOK]) {
          totalCount
        }
        manualProperty: properties(bookingJourneys: [MANUAL, FULL_AUTOMATIC]) {
          totalCount
        }
        herculesProperty: properties(bookingJourneys: [SEMI_AUTOMATIC]) {
          totalCount
        }
        leadProperty: properties(bookingJourneys: [LEAD_GENERATION]) {
          totalCount
        }
      }
    }
  }
`;

export const QUERY_BOOKINGS_STATISTICS = gql`
  query queryBookingsStatistics($createdAfter: VerifyDate, $propertyIds: [ID]) {
    viewer {
      ... on LandlordContact {
        company {
          herculesWeeklyOrders: orders(
            createdAfter: $createdAfter
            stages: [WAITING_FOR_CONFIRMATION]
            propertyIds: $propertyIds
            bookingJourneys: [SEMI_AUTOMATIC]
          ) {
            totalCount
          }
          herculesAllOrders: orders(propertyIds: $propertyIds, bookingJourneys: [SEMI_AUTOMATIC]) {
            totalCount
          }
          instantAllOrders: orders(propertyIds: $propertyIds, bookingJourneys: [INSTANT_BOOK]) {
            totalCount
          }
          leadGenAllOrders: orders(propertyIds: $propertyIds, bookingJourneys: [LEAD_GENERATION]) {
            totalCount
          }
          instantWeeklyOrders: orders(
            createdAfter: $createdAfter
            stages: [SIGNING_AGREEMENT, MAKING_PAYMENT, FILLING_PERSONAL_INFO]
            propertyIds: $propertyIds
            bookingJourneys: [INSTANT_BOOK]
          ) {
            totalCount
          }
          manualAllBookings: bookings(
            propertyIds: $propertyIds
            opportunityStages: [COMPLETED, CANCELLATION]
          ) {
            totalCount
          }
        }
      }
    }
  }
`;

export const QUERY_UNIT_TYPES = gql`
  query propertyUnitTypes($propertyId: ID) {
    listUnitTypes(propertyId: $propertyId) {
      edges {
        node {
          id
          name
          category
          floors
          roomSize
          roomType
          bathroomType
          viewType
          kitchenArrangement
          bedCount
          bedroomCountMin
          bedroomCountMax

          genderMix
          smokingPreference
          dietaryPreference

          unitTypeBedSizes {
            type
            length
            width
            bedCount
          }

          listings(journey: SEMI_AUTOMATIC, defaultSortRule: FIXED_OR_WAITING_LIST_TOP) {
            id
            type
            moveInType
            moveOutType
            moveIn
            moveOut
            tenancyLengthType
            tenancyLengthValue
            availability
            state
            priceMin
            priceMax
            discountValue
            discountType
            availableThoughMoveInDatePassed
          }

          price {
            isFrom
            minPrice
            discountedMinPrice
          }
        }
      }
    }
  }
`;

export const QUERY_ORDER_PRICE = gql`
  query calculateOrderPrice(
    $listingId: ID!
    $manualDiscountType: DiscountType
    $manualDiscountValue: String
    $moveInDate: VerifyDate!
    $moveOutDate: VerifyDate!
  ) {
    calculateOrderPrice(
      listingId: $listingId
      manualDiscountType: $manualDiscountType
      manualDiscountValue: $manualDiscountValue
      moveInDate: $moveInDate
      moveOutDate: $moveOutDate
    ) {
      nonInstalments {
        billingCycle
        listingSalesOriginPrice
        listingSalesPrice
        totalPrice
      }
    }
  }
`;

export const CREATE_COUNTER_OFFER = gql`
  mutation createOrderCounterOffer($input: CreateOrderCounterOfferInput) {
    createOrderCounterOffer(input: $input) {
      counterOffer {
        id
        listingId
      }
    }
  }
`;

export const CHECK_COUNTER_OFFER_INSTALMENT = gql`
  query checkOrderCounterOfferInstalment($input: CheckOrderCounterOfferInstalmentInput) {
    checkOrderCounterOfferInstalment(input: $input) {
      result
    }
  }
`;

export const QUERY_LANDLORD_PROPERTIES = gql`
  query queryLandlordProperties(
    $name: String
    $citySlug: String
    $pageSize: Int! = 20
    $pageNumber: Int! = 1
  ) {
    properties(
      name: $name
      citySlug: $citySlug
      sortBy: STATUS_NAME
      statuses: [EDITING, PUBLISHED, UNPUBLISHED]
      bookingJourneys: [SEMI_AUTOMATIC]
      pageNumber: $pageNumber
      pageSize: $pageSize
    ) {
      totalCount
      edges {
        node {
          name
          slug
          id
          state
          status
        }
      }
    }
  }
`;

export const QUERY_University = gql`
  query University($slug: String) {
    university(slug: $slug) {
      name
      slug
    }
  }
`;
